import { useState, useEffect } from "react";

export function usePrevious<P>(price: P | "loading" | "error" | undefined): P | undefined {
  const [previousPrice, setPreviousPrice] = useState<P | undefined>(() =>
    price !== "loading" && price !== "error" && price ? price : undefined,
  );

  useEffect(() => {
    if (price !== "loading" && price !== "error" && price) {
      setPreviousPrice(currentPrice => (currentPrice !== price ? price : currentPrice));
    }
  }, [price]);

  return previousPrice;
}
